import React, {useState} from 'react'
import FormikForm from '../form/FormikForm'
import Translator from '../common/translate/Translator'
import {useDispatch, useSelector} from 'react-redux'
import {UploadDocumentRequest, BooleanApiData} from '../../api/data-contracts'
import {Api_Document_UploadDocument} from '../../apiClient/apiClient'
import {getAdminState} from '../../redux/adminSlice'
import {postRequestAsync} from '../../redux/commonSlice'
import {getDocumentState} from '../../redux/documentSlice'
import {convertBase64} from '../../utils/utilities'
import {KTSVG} from '../../../_metronic/helpers'
import FormErrorMessage from '../common/messages/FormErrorMessage'
import FormInput from '../form/FormInput'

function FileUploadForm(props: {
  handleClose: () => void
  guidId?: string | null | undefined
  documentTypeId: number
  companyGuidId?: string
}) {
  const dispatch = useDispatch()
  const adminState = useSelector(getAdminState)
  const documentState = useSelector(getDocumentState)
  const hiddenFileInput = React.useRef<HTMLInputElement>(null)

  const [file, setFile] = useState<File | null>(null)
  const [error, setError] = useState('')

  const expectedExtensions = [
    'image/jpeg',
    'image/png',
    'application/pdf',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  ]

  let initialValues: UploadDocumentRequest = {
    documentType: props.documentTypeId,
    companyId: props.companyGuidId,
  }

  const handleUploadClick = (event: any) => {
    hiddenFileInput?.current?.click()
  }

  async function onFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    if ((event.target.files?.length ?? 0) > 0) {
      const file = (event.target.files ?? [])[0]

      const fileSizeLimit = 50 * 1024 * 1024

      if (file && file.size > fileSizeLimit) {
        setError('50MB dan büyük dosya yükleyemezsiniz.')
        setFile(null)
      } else if (!expectedExtensions.includes(file.type)) {
        setError(
          'Kabul edilmeyen dosya türü. Yükleyebileceğiniz dosya türleri: .jpeg, .png, .pdf, .xlsx, .docx.'
        )
        setFile(null)
      } else {
        setError('')
        setFile(file)
      }
    }
  }

  async function uploadDocument(request: UploadDocumentRequest) {
    request.base64Content = (await convertBase64(file)) as string
    request.extension = file?.type ?? ''
    request.fileName = file?.name ?? ''
    request.guidId = props.guidId

    await dispatch<any>(
      postRequestAsync({
        postRequestFunction: Api_Document_UploadDocument,
        body: request,
      })
    )
      .unwrap()
      .then(async (response: BooleanApiData) => {
        props.handleClose()
      })
  }

  return (
    <div className='d-flex flex-row-fluid flex-center bg-body rounded w-100 h-100'>
      <div className={'w-100 h-100 d-flex flex-row-fluid flex-center justify-content-center'}>
        <FormikForm initialValues={initialValues} onSubmit={uploadDocument}>
          {(form_props) => {
            return (
              <div className='d-flex flex-center'>
                <div className='w-100'>
                  <div className='d-flex flex-row'>
                    <div>
                      <input
                        type='file'
                        className='form-control form-control-solid'
                        onChange={onFileChange}
                        ref={hiddenFileInput}
                        style={{display: 'none'}}
                      />
                      <button
                        type='button'
                        className='btn btn-flex btn-primary'
                        onClick={handleUploadClick}
                      >
                        <KTSVG
                          path='/media/icons/duotune/files/fil018.svg'
                          className='svg-icon-muted svg-icon-x'
                        />
                        Dosya Seç
                      </button>
                    </div>
                    <div className='d-flex align-items-center ms-5'>
                      <span>{file?.name}</span>
                    </div>
                  </div>
                  <div className='row mt-2'>
                    <div className='col-12'>
                      <FormInput
                        fieldAttributes={{
                          type: 'text',
                          name: 'description',
                          placeholder: 'Döküman Notu',
                          as: 'textarea',
                          row: 5,
                        }}
                        istouched={form_props.touched.description ?? false}
                        errorMessage={form_props.errors.description}
                        placeHolderOnTop={true}
                        checkValid={false}
                      />
                    </div>
                  </div>
                  <div className='row mt-2'>
                    {error && (
                      <div className='col-6 offset-3'>
                        <FormErrorMessage message={error} />
                      </div>
                    )}
                  </div>
                  <div className='row'>
                    <div className='d-flex flex-row-reverse'>
                      <div>
                        <button
                          type='submit'
                          disabled={!form_props.isValid || !file}
                          className='btn btn-lg btn-primary mt-2'
                        >
                          <span className='indicator-label'>
                            <Translator name='KAYDET' />
                          </span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )
          }}
        </FormikForm>
      </div>
    </div>
  )
}

export default FileUploadForm
